import React from "react";
import PropTypes from "prop-types";

import styles from "./CenterContainer.module.css";
/**
 * Center Container
 * @param {Object} props {title: string (title of form), children: children (inside the form)}
 */
const CenterContainer = (props) => {
  return (
    <div className={styles.Container}>
      <div className={styles.Title}>{props.title}</div>
      {props.children}
    </div>
  );
};
CenterContainer.propTypes = {
  title: PropTypes.string,
};
export default CenterContainer;
